// extracted by css-extract-rspack-plugin
export default {"anchorLinkMenu":"vs_4B","visible":"O6wZQ"};